import { render, staticRenderFns } from "./FareCollection.vue?vue&type=template&id=09f5e7de&scoped=true"
import script from "./FareCollection.vue?vue&type=script&lang=js"
export * from "./FareCollection.vue?vue&type=script&lang=js"
import style0 from "./FareCollection.vue?vue&type=style&index=0&id=09f5e7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f5e7de",
  null
  
)

export default component.exports